import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    resignation: [],
}

const resignSlice = createSlice({
    name: 'resignation',
    initialState,
    reducers: {
        addResign: (state, action)=>{
            state.resignation = action.payload
        },
    }
})

export const handleAddResign= (state)=>{
    return dispatch => {
        dispatch(resignSlice.actions.addResign(state))
    }
}


export default resignSlice.reducer